import i18n, { Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';
import english from './locales/en.json';
import { Language } from './LocalizationEnum';

const resources: Resource = {
  [Language.en]: { translation: english },
};

export const initLocalization = async (): Promise<void> => {
  await i18n.use(initReactI18next).init({
    lng: Language.en,
    fallbackLng: Language.en,
    postProcessPassResolved: true,
    supportedLngs: Object.values(Language),
    resources,
    returnObjects: false,
    interpolation: {
      escapeValue: false,
    },
  });
};
